import React from 'react';
import PropTypes from 'prop-types';
import { efesBorder } from '../../theme';

const Cancel = ({ width, height, color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 17.437 17.437">
    <path
      d="M9-15.469A8.719,8.719,0,0,0,.281-6.75,8.719,8.719,0,0,0,9,1.969,8.719,8.719,0,0,0,17.719-6.75,8.719,8.719,0,0,0,9-15.469Zm4.574,4.145A6.47,6.47,0,0,1,14.3-3.04L5.29-12.051A6.47,6.47,0,0,1,13.574-11.324ZM4.426-2.176A6.47,6.47,0,0,1,3.7-10.46L12.71-1.449A6.47,6.47,0,0,1,4.426-2.176Z"
      transform="translate(-0.281 15.469)"
      fill={color}
    />
  </svg>
);

Cancel.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
};

Cancel.defaultProps = {
  width: 17.437,
  height: 17.437,
  color: efesBorder,
};

export default Cancel;
